<script lang="ts" setup>
import ProblemPresentationCard from '../ProblemPresentation/ProblemPresentationCard.vue';

defineProps<{
  imageNumber: InstanceType<
    typeof ProblemPresentationCard
  >['$props']['imageNumber'];
}>();
</script>

<template>
  <ProblemPresentationCard :image-number="imageNumber">
    <template #titleText>
      適正な<span :class="$style['card__text--accent']"
        >住宅ローンの返済額や頭金</span
      >はどのくらい？
    </template>
    <template #detail>
      無理なく返済できる毎月の返済額が知りたい。頭金はどのくらい用意したらいいのかわからない。
    </template>
  </ProblemPresentationCard>
</template>

<style lang="scss" module>
.card {
  &__text {
    &--accent {
      color: $color-text-and-object-accent-primary;
    }
  }
}
</style>
